// Modal.jsx
import { useEffect } from "react";
import { createPortal } from "react-dom";
import { motion as Motion, AnimatePresence } from "framer-motion";

export default function Modal({ isOpen, onClose, large, children }) {
  // Bloquear scroll del body cuando esté abierto
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => (document.body.style.overflow = "");
  }, [isOpen]);

  // Cerrar con tecla ESC
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  return createPortal(
    <AnimatePresence>
      {isOpen && (
        <Motion.div
          key="modal"
          initial={{ opacity: 0, top: "-100%" }}
          animate={{ opacity: 1, top: "0" }}
          exit={{ opacity: 0, top: "-100%" }}
          className="fixed inset-0 bg-aw-bluedark-30 flex items-center justify-center z-[99]"
          onClick={onClose}
          aria-modal="true"
          role="dialog"
        >
          <Motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.1, opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
            className={`bg-transparent shadow-lg p-6 ${large} w-full relative`}
            onClick={(e) => e.stopPropagation()} // Evita cerrar si clic en el contenido
          >
            {/* Botón de cerrar */}
            <button
              onClick={onClose}
              className="absolute top-8 right-9 text-white hover:text-gray-500 font-semibold duration-300 transition-text z-50"
              aria-label="Cerrar modal"
            >
              ✕
            </button>
            {children}
          </Motion.div>
        </Motion.div>
      )}
    </AnimatePresence>,
    document.body
  );
}
